<script>
import {
  onMounted, watch,
} from 'vue';

import { useRouter } from 'vue-router';

// State
import useSectionState from '@/state/useSectionState';
// Components
import useMainState from '@/state/useMainState';

import { getSummaryRouteType, getPropertyIdRouteParam } from '@/utils/getUserTypeDefaultRedirect';

export default {
  setup() {
    const {
      scrollbarOffsetHeight,
    } = useSectionState();

    const { propertyId } = useMainState();

    const router = useRouter();

    onMounted(() => {
      watch(propertyId, async () => {
        await router.replace({
          params: {
            propertyId: getPropertyIdRouteParam(),
            type: getSummaryRouteType(),
          },
        });
      }, {
        flush: 'post',
        immediate: true,
      });
    });

    return {
      scrollbarOffsetHeight,
      propertyId,
    };
  },
};
</script>

<template>
  <div>
    <div>
      <div
        class="relative m-auto"
        :style="{
          height: `calc(100vh - ${scrollbarOffsetHeight}px)`,
        }"
      >
        <div
          :key="propertyId"
          class="p-8 overflow-hidden section-content"
        >
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
